// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__niIWV","content":"styles_content__2i_fH"};